/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import OptimizationService from '../../service/optimization';
import _ from 'lodash';
import WyUtils from '../../library/wy-utils.js';
import WyFilter from '../../library/wy-filter.js';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async fetchOptimizationFilters({ getters, dispatch, rootState }, { pageName }) {
    return new Promise(async (resolve) => {
      const dataModel = rootState.site.pages[pageName].dataModel;

      if (!dataModel.dateMax) {
        dataModel.filters = {
          languages: { label: 'Language', name: 'languages', value: [], type: 'checkbox', isRequire: true, category: 'moreFilters' },
          custTypes: { label: 'Channel', name: 'custTypes', value: [], type: 'checkbox', isRequire: true },
        };

        //call api to get real data
        let res = await OptimizationService.fetchOptimizationFilters(getters.authUser);
        if (res && res.status == 200 && res.data) {
          // date limits
          if (res.data.dateLimits && res.data.dateLimits.length > 0) {
            dataModel.dateMin = res.data.dateLimits[0].firstDate;
            dataModel.dateMax = res.data.dateLimits[0].lastDate;
          }

          // language list
          if (dataModel.filters.languages) {
            let languageMap = WyUtils.languageMap;
            dataModel.filters.languages.dataSource = (res.data.languages || []).map((item) => {
              return { key: item.language, label: languageMap[item.language.toLowerCase()] };
            });
            dataModel.filters.languages.value = dataModel.filters.languages.dataSource.map((item) => item.key);
          }

          // custTypes list
          if (dataModel.filters.custTypes) {
            dataModel.filters.custTypes.dataSource = (res.data.custTypes || []).map((item) => {
              return { key: item.custType, label: WyUtils.toCamelCase(item.custType) };
            });
            dataModel.filters.custTypes.value = dataModel.filters.custTypes.dataSource.map((item) => item.key);
          }

          await dispatch('initFilterOriginalSource');
          resolve();
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  },

  async fetchConversationsData({ getters, dispatch }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationConversationsSummary(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      dispatch('amplitudeLogFetchData', { eventName: 'performance_comparison_page_loaded', payload: payload });
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchMessagesData({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationMessagesSummary(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  // corpusSummary
  async fetchOptimizationCorpusSummary({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationCorpusSummary(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonConversations({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonConversations(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonResponse({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonResponse(getters.authUser, payload);
    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationComparisonContained({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonContained(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonFeedback({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonFeedback(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonUnderstanding({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonUnderstanding(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonNluTraning({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonNluTraning(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonCorpus({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonCorpus(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonHandedOff({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonHandedOff(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationComparisonIssues({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (options && options.filters && Object.keys(options.filters).length > 0) {
      Object.keys(options.filters).forEach((key) => {
        payload[key] = options.filters[key];
      });
    }
    let res = await OptimizationService.fetchOptimizationComparisonIssues(getters.authUser, payload);
    if (res && res.status == 200 && res.data.length > 0) {
      return formatedData(getters, res.data);
    } else {
      return [];
    }
  },

  async fetchOptimizationChartData({ getters, dispatch }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverView(getters.authUser, payload);
    if (res && res.status && res.status == 200) {
      dispatch('amplitudeLogFetchData', { eventName: 'optimization_overview_page_loaded', payload: payload });
      //   res.data = {
      //     "totalPerformanceMetric": {
      //         "understanding": -1,
      //         "containment": -1,
      //         "negativeFeedbackScore": -1,
      //         "rawData": {
      //             "NumberOfConversations": 0,
      //             "NumberOfCustomerMessages": 0,
      //             "CustomerMessagesUnderstood": 0,
      //             "NumberOfContainedConversations": 0,
      //             "NumberOfConversationsReceivedFeedback": 0,
      //             "NumberOfConversationsReceivedNeg": 0
      //         }
      //     },
      //     "dailyMetrics": []
      // }
      return formatPerformanceMetricsChartData(getters, res.data);
    } else {
      return {};
    }
  },

  async fetchOptimizationResponseChartData({ getters, dispatch }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationResponse(getters.authUser, payload);

    dispatch('amplitudeLogFetchData', { eventName: 'optimization_response_page_loaded', payload: payload });

    return formatResponseMetricsChartData(getters, res.data);
  },

  //Add and remove response
  addResponse({ getters, dispatch, rootState }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (data.responseId) payload.responseId = data.responseId;

    dispatch('logAmplitudeWithFilters', { eventName: 'add_response', eventProperties: {where: rootState.auth.trackInfo.where}, filterProperties: payload });
    return OptimizationService.addResponse(getters.authUser, payload);
  },

  removeResponse({ getters, dispatch, rootState }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (data.responseId) payload.responseId = data.responseId;

    dispatch('logAmplitudeWithFilters', { eventName: 'remove_response', eventProperties: {where: rootState.auth.trackInfo.where}, filterProperties: payload });
    return OptimizationService.removeResponse(getters.authUser, payload);
  },

  //add intent and remove
  addIntent({ getters, dispatch, rootState }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (data.intent) payload.intent = data.intent;

    dispatch('logAmplitudeWithFilters', {eventName: 'add_intent', eventProperties: {where: rootState.auth.trackInfo.where}, filterProperties: payload });
    return OptimizationService.addIntent(getters.authUser, payload);
  },

  removeIntent({ getters, dispatch, rootState }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if (data.intent) payload.intent = data.intent;

    dispatch('logAmplitudeWithFilters', {eventName: 'remove_intent', eventProperties: {where: rootState.auth.trackInfo.where}, filterProperties: payload });
    return OptimizationService.removeIntent(getters.authUser, payload);
  },

  async fetchOptimizationOverViewConversations({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewConversations(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },
  async fetchOptimizationOverViewContained({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewContained(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewFeedback({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewFeedback(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewUnderstanging({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewUnderstanging(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewNluTraning({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewNluTraning(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewCorpus({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewCorpus(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewHandedOff({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewHandedOff(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewIssues({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewIssues(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationOverViewResponses({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationOverViewResponses(getters.authUser, payload);

    // dispatch('amplitudeLogFetchData', {eventName: 'optimization_overview_page_loaded', payload: payload});
    return formatedData(getters, res.data);
  },

  async fetchOptimizationIntentPerformance({ getters, dispatch }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await OptimizationService.fetchOptimizationIntentPerformance(getters.authUser, payload);

    dispatch('amplitudeLogFetchData', { eventName: 'intent_performance_page_loaded', payload: payload });
    return formatIntentPerformanceChartData(getters, res.data);
  },

  // async fetchOptimizationResponse({getters, dispatch}) {
  //   let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
  //   let res = await OptimizationService.fetchOptimizationResponse(getters.authUser, payload);

  //   dispatch('amplitudeLogFetchData', {eventName: 'response_page_loaded', payload: payload});
  //   return formatResponseChartData(getters, res.data)
  // },

  // async prepareResponseViewByData({getters, commit},{viewBy, rawData, templateData, companyConfig}) {
  //   if(rawData && Object.keys(rawData).length > 0) {
  //     let viewByData = JSON.parse(JSON.stringify(rawData));
  //     let viewByDailyData = JSON.parse(JSON.stringify(rawData));
  //     let panelName = Object.keys(viewByData)[0]

  //     if(viewBy && panelName) {
  //       switch (panelName) {
  //         case 'containedConversations':
  //           viewByData.containedConversations.containmentRateLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData.containedConversations.containmentRateLineChartData, ['containmentRate'])
  //           viewByData.containedConversations.containmentRateLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData.containedConversations.containmentRateLineChartData, ['containmentRate'])
  //           viewByData.containedConversations.containmentRateLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData.containedConversations.containmentRateLineChartData, ['containmentRate'])

  //           return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy);

  //         default:
  //       }
  //     }
  //     else {
  //       return {}
  //     }
  //   }
  //   else {
  //     return templateData;
  //   }
  // },

  async exportIntentAction({ getters, dispatch }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.intent = options.intent;
    payload.action = options.actionType;
    //export intent action log
    dispatch('amplitudeLogFetchData', { eventName: 'export_intent_action', payload: payload });
    return OptimizationService.exportIntentAction(getters.authUser, payload);
  },

  async fetchIntentAction({ getters, dispatch }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.intent = options.intent;
    payload.action = options.actionType;
    let res = await OptimizationService.fetchIntentAction(getters.authUser, payload);
    let map = {
      yes: 'Yes',
      no: 'No',
    };
    if (res.data && Object.keys(res.data).length > 0) {
      let data = {
        intentActionDetail: {
          '# times presented': {
            isActive: false,
            list: [res.data.timesPresented],
            // list: ['Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my accountHey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account','update info','update info','Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account','Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my accountHey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account','update info','update info','Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account','Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my accountHey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account','update info','update info','Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account Hey I need help logging in to my account']
          },
          '# utterances': {
            isActive: false,
            list: res.data.utteranceMessages,
          },
          'False positives': {
            isActive: false,
            list: res.data.falsePositivesMessages,
          },
          'Paraphrase candidates': {
            isActive: false,
            list: res.data.paraphraseCandidateMessages,
          },
          'DYM Candidates': {
            isActive: false,
            list: res.data.dymCandidateMessages,
          },
          'Similar utterances': {
            isActive: false,
            list: res.data.similarUtteranceMessages,
          },
          'Low quality utterances': {
            isActive: false,
            list: res.data.lowQualityUtteranceMessages,
          },
          'Undertrained intent': {
            isActive: false,
            list: map[res.data.isUnderTrained] ? [map[res.data.isUnderTrained]] : [res.data.isUnderTrained],
          },
        },
      };
      if (data.intentActionDetail['# utterances'].length == 0) {
        data.intentActionDetail['# utterances'] = [0];
      }
      dispatch('amplitudeLogFetchData', { eventName: 'intent_action_page_loaded', payload: payload });
      return data;
    } else {
      return null;
    }
  },

  async fetchOptimizationUnclassifiedCategories({ getters, dispatch }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);

    dispatch('amplitudeLogFetchData', { eventName: 'unclassified_categories', payload: payload });
    return OptimizationService.fetchOptimizationUnclassifiedCategories(getters.authUser, payload);
  },

  async fetchOptimizationUnclassifiedTopics({ getters, dispatch }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.category = data.category;

    dispatch('amplitudeLogFetchData', { eventName: 'unclassified_topics', payload: payload });
    return OptimizationService.fetchOptimizationUnclassifiedTopics(getters.authUser, payload);
  },

  // async fetchOptimizationUnclassifiedMessages({getters, dispatch}, data) {
  //   let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
  //   payload.category = data.category;
  //   payload.topic = data.topic;

  //   dispatch('amplitudeLogFetchData', {eventName: 'unclassified_messsages', payload: payload});
  //   return OptimizationService.fetchOptimizationUnclassifiedMessages(getters.authUser, payload);
  // },

  async fetchOptimizationUnclassifiedMessagesWithToBeActioned({ getters, dispatch }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.category = data.category;
    payload.topic = data.topic;
    payload.pageSize = data.pageSize;
    payload.pageNumber = data.pageNumber;
    payload.keyword = data.keyword;

    dispatch('amplitudeLogFetchData', { eventName: 'unclassified_messsages', payload: payload });
    return OptimizationService.fetchOptimizationUnclassifiedMessagesWithToBeActioned(getters.authUser, payload);
  },

  async fetchOptimizationUnclassifiedMessagesWithActioned({ getters, dispatch }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.category = data.category;
    payload.topic = data.topic;
    payload.pageSize = data.pageSize;
    payload.pageNumber = data.pageNumber;
    payload.keyword = data.keyword;

    dispatch('amplitudeLogFetchData', { eventName: 'unclassified_messsages', payload: payload });
    return OptimizationService.fetchOptimizationUnclassifiedMessagesWithActioned(getters.authUser, payload);
  },

  async fetchOptimizationUnclassifiedMessagesWithDiscard({ getters, dispatch }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.category = data.category;
    payload.topic = data.topic;
    payload.pageSize = data.pageSize;
    payload.pageNumber = data.pageNumber;
    payload.keyword = data.keyword;

    dispatch('amplitudeLogFetchData', { eventName: 'unclassified_messsages', payload: payload });
    return OptimizationService.fetchOptimizationUnclassifiedMessagesWithDiscard(getters.authUser, payload);
  },

  async saveOptimizationUnclassifiedMessages({ getters }, items) {
    let clonedItems = JSON.parse(JSON.stringify(items));
    clonedItems.map((item) => {
      delete item.originItem;
    });

    return OptimizationService.saveOptimizationUnclassifiedMessages(getters.authUser, clonedItems);
  },

  async fetchOptimizationUnclassifiedIntents({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);

    return OptimizationService.fetchOptimizationUnclassifiedIntents(getters.authUser, payload);
  },

  async fetchOptimizationResponsePerformanceSummary({ getters, commit, dispatch, rootState }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.savedResponses = (options && options.savedResponses) || false;
    payload.searchResponseTerm = options && options.keyword ? options.keyword : null;

    let res = await OptimizationService.fetchOptimizationResponsePerformanceSummary(getters.authUser, payload);
    if (res && res.status === 200 && res.data) {
      res.data.results.forEach(item => {
        item.language = item.language.join(", ");
      })
      if( payload.savedResponses) {
        dispatch('logAmplitudeWithFilters', {eventName: 'view_saved_responses', eventProperties: {where: rootState.auth.trackInfo.where, number_of_saved_responses: res.data.results.length}, filterProperties: payload });
      }
      commit('updateTableModelResult', {
        results: res.data.results,
        totalRecs: res.data.totalResponses,
        totalPages: 1,
      });

      return new Promise((resolve) => {
        resolve(true);
      });
    } else {
      return new Promise((resolve) => {
        resolve(false);
      });
    }
  },
  async fetchOptimizationIntentPerformanceSummary({ getters, commit, dispatch, rootState }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let availableCustTypes = JSON.parse(JSON.stringify(getters.dataModel.filters.custTypes.value));
    payload.availableCustTypes = availableCustTypes;

    payload.savedIntentsOnly = (options && options.savedIntents) || false;

    let res = await OptimizationService.fetchOptimizationIntentPerformanceSummary(getters.authUser, payload);
    if (res && res.status === 200 && res.data) {
      for (const item of res.data) {
        if(typeof item.totalUtterances == 'undefined') {
          item.totalUtterancesSortBy = -1;
        }
        else {
          item.totalUtterancesSortBy = item.totalUtterances;
        }
        if(typeof item.totalDuplicateUtterances == 'undefined') {
          item.totalDuplicateUtterancesSortBy = -1;
        }
        else {
          item.totalDuplicateUtterancesSortBy = item.totalDuplicateUtterances;
        }
        if(typeof item.totalInconsistentUtterances == 'undefined') {
          item.totalInconsistentUtterancesSortBy = -1;
        }
        else {
          item.totalInconsistentUtterancesSortBy = item.totalInconsistentUtterances;
        }
        
        if(item.blackListed) {
          item.prioritySortBy = 999999;
          item.issuesChangeWithoutAbs = -999999;
          item.confidenceScoreChangeWithoutAbs = -999999;
          item.falsePositivesChangeWithoutAbs = -999999;
          item.dymChangeWithoutAbs = -999999;
          item.botRepetitionsChangeWithoutAbs = -999999;
          item.trainingCandidatesChangeWithoutAbs = -999999;
          item.duplicateUtterancesChangeWithoutAbs = -999999;
          item.inconsistentUtterancesChangeWithoutAbs = -999999;
          item.totalUtterancesSortBy = -999999;
          item.totalDuplicateUtterancesSortBy = -999999;
          item.totalInconsistentUtterancesSortBy = -999999;
        }
        else {
          item.prioritySortBy = item.priority;
        }
      }
      // multiply by xnumber
      if (getters.xnumber && getters.xnumber > 1) {
        for (const item of res.data) {
          item.totalVolume = item.totalVolume * getters.xnumber;
          item.totalVolumeCompare = item.totalVolumeCompare * getters.xnumber;
        }
      }

      if( payload.savedIntentsOnly) {
        dispatch('logAmplitudeWithFilters', {eventName: 'view_saved_intents', eventProperties: {where: rootState.auth.trackInfo.where, number_of_saved_intents: res.data.length}, filterProperties: payload });
      }

      commit('updateTableModelResult', {
        results: res.data,
        totalRecs: res.data.length,
        totalPages: 1,
      });

      return new Promise((resolve) => {
        resolve(true);
      });
    } else {
      return new Promise((resolve) => {
        resolve(false);
      });
    }
  },
};

function formatedData(getters, data) {
  let list = [];
  let totalFieldTypeMap = {
    numOfSessions: 'number',
    numOfConversations: 'number',
    numberOfCustomerMessages: 'number',
    numberOfBotResponses: 'number',
    numberOfIntents: 'number',
    numberOfUtterances: 'number',
    numberOfUtterancesWithoutWildcards: 'number',
    numberOfWildcardUtterances: 'number',
  };
  let avaiableItem = {};
  if (data && Array.isArray(data)) {
    data.forEach((item) => {
      if (item && item.data && item.data.length > 0) {
        avaiableItem = JSON.parse(JSON.stringify(item));
        return false;
      }
    });
    data.forEach((item) => {
      if (item && item.data && item.data.length == 0 && Object.keys(avaiableItem).length > 0) {
        item.data = avaiableItem.data;
        item.data.forEach((dataItem) => {
          Object.keys(dataItem).forEach((key) => {
            if (key != 'label') {
              dataItem[key] = null;
            }
          });
        });
      }
    });

    data.forEach((item) => {
      let result = item.name.replace(/([A-Z])/g, ' $1');
      item.label = result.charAt(0).toUpperCase() + result.slice(1);
      item['rowKey'] = item.name;
      item['totalRaw'] = item.total;
      if (item.total == null) {
        item.total = '-';
      } else {
        if (!totalFieldTypeMap[item.name]) {
          item.total = item.total + '%';
        }
      }

      // multiply by xnumber
      const columnsMultiplyByXnumber = ['numOfSessions', 'numOfConversations', 'numberOfCustomerMessages'];
      if (getters.xnumber && getters.xnumber > 1 && columnsMultiplyByXnumber.includes(item.name)) {
        item.total = item.total * getters.xnumber;
        if (item.data && item.data.length > 0) {
          for (let itemData of item.data) {
            itemData.value = itemData.value * getters.xnumber;
          }
        }
      }
      if (item && item.data && item.data.length > 0 && Object.keys(avaiableItem).length > 0) {
        item.data.forEach((column) => {
          if (!item.dynamicFields) {
            item.dynamicFields = [];
          }
          let fieldObj = {};
          let dynamicFieldName = column.label;

          if (column.hasOwnProperty('percentage')) {
            if (column.percentage == null) {
              fieldObj[dynamicFieldName] = '-';
              item[dynamicFieldName] = '-';
              item[dynamicFieldName + 'Raw'] = '-';
            } else {
              fieldObj[dynamicFieldName] = null;
              item[dynamicFieldName] = column.percentage + '%';
              item[dynamicFieldName + 'Raw'] = column.percentage;
            }
          } else {
            if (column.value == null) {
              fieldObj[dynamicFieldName] = '-';
              item[dynamicFieldName] = '-';
              item[dynamicFieldName + 'Raw'] = '-';
              fieldObj.fieldType = 'number';
            } else {
              fieldObj[dynamicFieldName] = null;
              item[dynamicFieldName] = column.value;
              item[dynamicFieldName + 'Raw'] = column.value;
              fieldObj.fieldType = 'number';
            }
          }
          item.dynamicFields.push(fieldObj);
        });
      }
      list.push(item);
    });
  }
  return list;
}

function formatIntentPerformanceChartData(getters, data) {
  let legendOriginColors = [];
  if (getters.companyConfig && getters.companyConfig.legends && getters.companyConfig.legends.legendColors && getters.companyConfig.legends.legendColors.length > 0) {
    legendOriginColors = _.uniq(_.concat(getters.companyConfig.legends.legendColors, getters.legendDefaultColors));
  } else {
    legendOriginColors = getters.legendDefaultColors;
  }
  let rtnData = {}
  if (data && data.totalPerformanceMetric) {
    rtnData = {
      totalPerformanceMetricData: {
        nlu: [
          {
            key: 'nlu',
            label: 'NLU',
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.nlu == -1 ? 'N/A' : data && data.totalPerformanceMetric && data.totalPerformanceMetric.nlu,
            defaultShow: true,
            color: legendOriginColors[0],
            toolTipContent:
              'The percent of customer messages where the classifier matched the message to an intent at a confidence level above the  threshold, this includes instances when a response was not served by the virtual agent due to a content gap',
          },
          {
            key: 'rest',
            label: 'Contained',
            drilldownId: 2,
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.nlu == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.nlu),
            defaultShow: true,
            color: '#C9D3DA',
          },
        ],
        falsePositives: [
          {
            key: 'falsePositives',
            label: 'False Positives',
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.falsePositives == -1 ? 'N/A' : data && data.totalPerformanceMetric.falsePositives,
            defaultShow: true,
            color: legendOriginColors[1],
            toolTipContent: 'The percent of customer messages where the bot responded but has in fact misunderstood the message and communicated an incorrect response',
          },
          {
            key: 'rest',
            label: 'Contained',
            drilldownId: 2,
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.falsePositives == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.falsePositives),
            defaultShow: true,
            color: '#C9D3DA',
          },
        ],
        messagesNotUnderstood: [
          {
            key: 'messagesNotUnderstood',
            label: 'Messages Not Understood',
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.messagesNotUnderstood == -1 ? 'N/A' : data && data.totalPerformanceMetric && data.totalPerformanceMetric.messagesNotUnderstood,
            defaultShow: true,
            color: legendOriginColors[2],
            toolTipContent: 'The percent of customer messages where the classifier was unable to match the message to an intent at a confidence level above the threshold',
          },
          {
            key: 'rest',
            label: 'Contained',
            drilldownId: 2,
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.messagesNotUnderstood == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.messagesNotUnderstood),
            defaultShow: true,
            color: '#C9D3DA',
          },
        ],
        lowQualityIntents: [
          {
            key: 'lowQualityIntents',
            label: 'Low Quality Intents',
            value:
              data && data.totalPerformanceMetric && data.totalPerformanceMetric.lowQualityIntents == -1
                ? 'N/A'
                : data && data.totalPerformanceMetric && data.totalPerformanceMetric.lowQualityIntents == -1
                ? 'N/A'
                : data && data.totalPerformanceMetric && data.totalPerformanceMetric.lowQualityIntents,
            defaultShow: true,
            color: legendOriginColors[3],
            toolTipContent: 'The percent of all intents that group utterances that are very different to each other',
          },
          {
            key: 'rest',
            label: 'Contained',
            drilldownId: 2,
            value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.lowQualityIntents == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.lowQualityIntents),
            defaultShow: true,
            color: '#C9D3DA',
          },
        ],
      },
      trendPerformanceMetricData: {
        dateList: [],
        nluList: [],
        messagesNotUnderstoodList: [],
        lowQualityIntentsList: [],
        falsePositivesList: [],
      },
    };
  }
  if (
    data && 
    data.totalPerformanceMetric &&
    data.totalPerformanceMetric.nlu == null &&
    data.totalPerformanceMetric.messagesNotUnderstood == null &&
    data.totalPerformanceMetric.lowQualityIntents == null &&
    data.totalPerformanceMetric.falsePositives == null
  ) {
    rtnData.totalPerformanceMetricData = null;
  }
  if (data && data.dailyMetrics && data.dailyMetrics.length > 0) {
    data.dailyMetrics.forEach((dailyMetric) => {
      rtnData.trendPerformanceMetricData.dateList.push(dailyMetric.date);
      rtnData.trendPerformanceMetricData.nluList.push(dailyMetric.nlu);
      rtnData.trendPerformanceMetricData.messagesNotUnderstoodList.push(dailyMetric.messagesNotUnderstood);
      rtnData.trendPerformanceMetricData.lowQualityIntentsList.push(dailyMetric.lowQualityIntents);
      rtnData.trendPerformanceMetricData.falsePositivesList.push(dailyMetric.falsePositives);
    });
  }
  return rtnData;
}

function formatPerformanceMetricsChartData(getters, data) {
  let legendOriginColors = [];
  if (getters.companyConfig && getters.companyConfig.legends && getters.companyConfig.legends.legendColors && getters.companyConfig.legends.legendColors.length > 0) {
    legendOriginColors = _.uniq(_.concat(getters.companyConfig.legends.legendColors, getters.legendDefaultColors));
  } else {
    legendOriginColors = getters.legendDefaultColors;
  }
  let rtnData = {
    totalPerformanceMetricData: {
      understanding: [
        {
          key: 'understandingTotal',
          label: 'Natural Language Understanding',
          value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.understanding == -1 ? 'N/A' : data && data.totalPerformanceMetric && data.totalPerformanceMetric.understanding,
          defaultShow: true,
          color: legendOriginColors[0],
          toolTipContent:
            'The percent of customer messages where the classifier matched the message to an intent at a confidence level above the threshold, this includes instances when a response was not served by the virtual agent due to a content gap',
        },
        {
          key: 'rest',
          label: 'Contained',
          drilldownId: 2,
          value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.understanding == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.understanding),
          defaultShow: true,
          color: '#C9D3DA',
        },
      ],
      containment: [
        {
          key: 'containmentTotal',
          label: 'VA Conversations Contained',
          value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.containment == -1 ? 'N/A' : data && data.totalPerformanceMetric && data.totalPerformanceMetric.containment,
          defaultShow: true,
          color: legendOriginColors[1],
          toolTipContent: 'The percent of virtual agent conversations that were contained by the virtual agent and did not include an attempt to escalate to a live agent',
        },
        {
          key: 'rest',
          label: 'Contained',
          drilldownId: 2,
          value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.containment == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.containment),
          defaultShow: true,
          color: '#C9D3DA',
        },
      ],
      //negativeFeedbackScore
      negativeFeedbackScore: [
        {
          key: 'negativeFeedbackScoreTotal',
          label: 'Negative Feedback Score',
          value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.negativeFeedbackScore == -1 ? 'N/A' : data && data.totalPerformanceMetric && data.totalPerformanceMetric.negativeFeedbackScore,
          defaultShow: true,
          color: legendOriginColors[2],
          toolTipContent: 'The percent of conversations with feedback received that was negative',
        },
        {
          key: 'rest',
          label: 'Contained',
          drilldownId: 2,
          value: data && data.totalPerformanceMetric && data.totalPerformanceMetric.negativeFeedbackScore == -1 ? 100 : 100 - (data && data.totalPerformanceMetric && data.totalPerformanceMetric.negativeFeedbackScore),
          defaultShow: true,
          color: '#C9D3DA',
        },
      ],
      // engagement: [
      //   {key: "engagementTotal", label: "Journey Completion", value: (data.totalPerformanceMetric.engagement==-1)?'N/A':data.totalPerformanceMetric.engagement, defaultShow: true, color: "#B261CE", toolTipContent: 'Engagement tooltips'},
      //   {key: "rest", label: "Contained", drilldownId: 2, value: (data.totalPerformanceMetric.engagement==-1)?100:(100 - data.totalPerformanceMetric.engagement), defaultShow: true, color: "#C9D3DA"}
      // ]
    },
    trendPerformanceMetricData: {
      dateList: [],
      understandingList: [],
      containmentList: [],
      negativeFeedbackScoreList: [],
      // engagementList: []
    },
    // conversationSummary: formatedData(getters, data.conversationSummary, 'conversations'),
    // messageSummary: formatedData(getters, data.messageSummary, 'messages'),
    // corpusSummary: formatedData(getters, data.corpusSummary, 'corpus')
  };
  if (
    data.totalPerformanceMetric &&
    data.totalPerformanceMetric.understanding == null &&
    data.totalPerformanceMetric.containment == null &&
    data.totalPerformanceMetric.negativeFeedbackScore == null
  ) {
    rtnData.totalPerformanceMetricData = null;
  }

  if (data && data.dailyMetrics && data.dailyMetrics.length > 0) {
    data.dailyMetrics.forEach((dailyMetric) => {
      rtnData.trendPerformanceMetricData.dateList.push(dailyMetric.date);
      rtnData.trendPerformanceMetricData.understandingList.push(dailyMetric.understanding);
      rtnData.trendPerformanceMetricData.containmentList.push(dailyMetric.containment);
      rtnData.trendPerformanceMetricData.negativeFeedbackScoreList.push(dailyMetric.negativeFeedbackScore);
      // rtnData.totalPerformanceMetricData.engagementList.push(dailyMetric.engagement);
    });
  }
  return rtnData;
}

function formatResponseMetricsChartData(getters, data) {
  let rtnData = {
    totalPerformanceMetricData: {
      handoffRate: [],
      negativeFeedbackRate: [],
      botRepetitionRate: [],
    },
    trendPerformanceMetricData: {
      dateList: [],
      handoffRateList: [],
      negativeFeedbackRateList: [],
      botRepetitionRateList: [],
      rawData: data,
    },
  };

  if (data && data.totalPerformanceMetric) {
    rtnData.totalPerformanceMetricData = {
      handoffRate: [
        { key: 'handoffRate', label: 'Handoff rate', value: data.totalPerformanceMetric.handoffRate == -1 ? 'N/A' : data.totalPerformanceMetric.handoffRate, defaultShow: true, color: '#4B67A3' },
        {
          key: 'rest',
          label: 'Non-Handoff rate',
          drilldownId: 2,
          value: data.totalPerformanceMetric.handoffRate == -1 ? 100 : 100 - data.totalPerformanceMetric.handoffRate,
          defaultShow: true,
          color: '#CAD2DA',
        },
      ],
      negativeFeedbackRate: [
        {
          key: 'negativeFeedbackRate',
          label: 'Negative feedback rate',
          value: data.totalPerformanceMetric.negativeFeedbackRate == -1 ? 'N/A' : data.totalPerformanceMetric.negativeFeedbackRate,
          defaultShow: true,
          color: '#5FBBAA',
        },
        {
          key: 'rest',
          label: 'Non-Negative feedback rate',
          drilldownId: 2,
          value: data.totalPerformanceMetric.negativeFeedbackRate == -1 ? 100 : 100 - data.totalPerformanceMetric.negativeFeedbackRate,
          defaultShow: true,
          color: '#CAD2DA',
        },
      ],
      botRepetitionRate: [
        {
          key: 'botRepetitionRate',
          label: 'Bot repetition rate',
          value: data.totalPerformanceMetric.botRepetitionRate == -1 ? 'N/A' : data.totalPerformanceMetric.botRepetitionRate,
          defaultShow: true,
          color: '#8E88DC',
        },
        {
          key: 'rest',
          label: 'Non-Bot repetition rat',
          drilldownId: 2,
          value: data.totalPerformanceMetric.botRepetitionRate == -1 ? 100 : 100 - data.totalPerformanceMetric.botRepetitionRate,
          defaultShow: true,
          color: '#CAD2DA',
        },
      ],
    };
  }
  if (data && data.totalPerformanceMetric) {
    rtnData.totalPerformanceMetricData = {
      handoffRate: [
        { key: 'handoffRate', label: 'Handoff rate', value: data.totalPerformanceMetric.handoffRate, defaultShow: true, color: '#4B67A3' },
        {
          key: 'rest',
          label: 'Non-Handoff rate',
          drilldownId: 2,
          value: data.totalPerformanceMetric.handoffRate == -1 ? 100 : 100 - data.totalPerformanceMetric.handoffRate,
          defaultShow: true,
          color: '#CAD2DA',
        },
      ],
      negativeFeedbackRate: [
        { key: 'negativeFeedbackRate', label: 'Negative feedback rate', value: data.totalPerformanceMetric.negativeFeedbackRate, defaultShow: true, color: '#5FBBAA' },
        {
          key: 'rest',
          label: 'Non-Negative feedback rate',
          drilldownId: 2,
          value: data.totalPerformanceMetric.negativeFeedbackRate == -1 ? 100 : 100 - data.totalPerformanceMetric.negativeFeedbackRate,
          defaultShow: true,
          color: '#CAD2DA',
        },
      ],
      botRepetitionRate: [
        { key: 'botRepetitionRate', label: 'Bot repetition rate', value: data.totalPerformanceMetric.botRepetitionRate, defaultShow: true, color: '#8E88DC' },
        {
          key: 'rest',
          label: 'Non-Bot repetition rat',
          drilldownId: 2,
          value: data.totalPerformanceMetric.botRepetitionRate == -1 ? 100 : 100 - data.totalPerformanceMetric.botRepetitionRate,
          defaultShow: true,
          color: '#CAD2DA',
        },
      ],
    };
  }
  if (
    data &&
    data.totalPerformanceMetric &&
    data.totalPerformanceMetric.handoffRate == null &&
    data.totalPerformanceMetric.negativeFeedbackRate == null &&
    data.totalPerformanceMetric.botRepetitionRate == null
  ) {
    rtnData.totalPerformanceMetricData = null;
  }

  if (data && data.dailyMetrics && data.dailyMetrics.length > 0) {
    data.dailyMetrics.forEach((dailyMetric) => {
      rtnData.trendPerformanceMetricData.dateList.push(dailyMetric.date);
      rtnData.trendPerformanceMetricData.handoffRateList.push(dailyMetric.handoffRate);
      rtnData.trendPerformanceMetricData.negativeFeedbackRateList.push(dailyMetric.negativeFeedbackRate);
      rtnData.trendPerformanceMetricData.botRepetitionRateList.push(dailyMetric.botRepetitionRate);
    });
  }
  return rtnData;
}

export default {
  state,
  getters,
  mutations,
  actions,
};
